import { CheckoutForm } from ".";
import { useFormContext } from "react-hook-form";
import { Icon } from "@circle-react/components/shared/Icon";
import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circle-react-uikit/Button";
import { Loader } from "@circle-react-uikit/Loader";
import { ElementsWithPMC } from "../../CheckoutForm/StripeElements/ElementsWithPMC";
import { usePayment } from "../../hooks/usePayment";
import { CheckoutDescription } from "../CheckoutDescription";
import { Column } from "../components/Column";
import { CheckoutFormAccountInfo } from "./CheckoutFormAccountInfo";
import { CheckoutFormSection } from "./CheckoutFormSection";
import { CheckoutFormTOS } from "./CheckoutFormTOS";
import { CheckoutFormTaxIdField } from "./CheckoutFormTaxIdField";
import { PaymentMethodSelectorForm } from "./PaymentMethodSelectorForm";

interface RootProps {
  className?: string;
}

export const Root = ({ className }: RootProps) => {
  const formMethods = useFormContext();
  const { handleSubmit } = formMethods;
  const { isProcessingPayment, authProviderProperties } =
    usePaywallCheckoutContext();

  const { onSubmit, payButtonLabel, stripe, isSubmitDisabled } = usePayment();

  if (authProviderProperties.is_sso_authentication_required) {
    return null;
  }

  return (
    <Column
      className={classNames(
        "flex h-auto w-full flex-col items-center lg:items-start",
        className,
      )}
    >
      <CheckoutDescription.CommunityHeader className="hidden lg:invisible lg:block" />
      {isProcessingPayment && <Loader variant="fullscreen" />}
      <form
        className="flex flex-col gap-y-6"
        onSubmit={handleSubmit(onSubmit)}
        data-testid="checkout-form"
      >
        <CheckoutForm.Alerts className="hidden lg:block" shouldFocus />
        <CheckoutFormAccountInfo />
        <CheckoutFormSection className="gap-y-5">
          <PaymentMethodSelectorForm />
          <ElementsWithPMC />
          <CheckoutFormTaxIdField />
        </CheckoutFormSection>
        <CheckoutForm.Alerts className="block lg:hidden" />
        <CheckoutFormSection className="gap-y-5">
          <CheckoutFormTOS />
          <Button
            type="submit"
            large
            variant="circle"
            disabled={!stripe || isSubmitDisabled || isProcessingPayment}
            data-testid="checkout-form-submit-button"
            className="flex flex-row items-center gap-x-2"
          >
            <Icon size={20} type="20-lock" />
            {payButtonLabel}
          </Button>
        </CheckoutFormSection>
      </form>
    </Column>
  );
};
